/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import { PracticeTestTypeEnum } from '__generatedTypes__/globalTypes'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { PracticeTestList } from 'pagesNew/PracticeTests'
import { FullLengthTestsTabs, FULL_LENGTH_TESTS_TAB_PARAM } from './consts'
import * as classes from './styles'

const tabs = Object.values(FullLengthTestsTabs).map((item) => ({ id: item, title: item }))

const FullLengthTests: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get(FULL_LENGTH_TESTS_TAB_PARAM)

  const activeTab = useMemo(() => {
    const foundTab = tabs.find((tab) => tab.id === tabParam)
    return foundTab ?? tabs[0]
  }, [tabParam])

  const handleTabChange = useCallback(
    (tab: TabsItem) => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev)
        newParams.set(FULL_LENGTH_TESTS_TAB_PARAM, tab.id)
        return newParams
      })
    },
    [setSearchParams]
  )

  const renderTab = () => {
    const { title } = activeTab

    if (title === FullLengthTestsTabs.FULL_LENGTH) {
      return (
        <>
          <DescriptionForm page={DescriptionPages.FullLengthTests} />
        </>
      )
    }

    if (title === FullLengthTestsTabs.MINI_LENGTH) {
      return (
        <>
          <DescriptionForm page={DescriptionPages.MiniLengthTests} />
          <div css={classes.miniTestsWrapper}>
            <PracticeTestList type={PracticeTestTypeEnum.MiniTest} />
          </div>
        </>
      )
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Full/Mini Tests
      </Typography>

      <TabsNavigation tabs={tabs} value={activeTab} onChange={handleTabChange} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}

export default FullLengthTests
